const LANDING_PAGE_PDV = {
  mainTitle: 'Quer aumentar suas vendas e ganhar uma renda extra?',
  mainSubTitle:
    'É só se cadastrar para dar o primeiro passo na nossa parceria!',
  newShop: 'CADASTRAR SUA LOJA',
  illustrationPDV: 'Ilustração de um PDV',
  benefitsTitle: 'Vantagens para sua loja',
  firstBenefitTitle: 'Divulgação',
  firstBenefitDescription: 'Divulgamos seus produtos na nossa plataforma.',
  secondBenefitTitle: 'Novos clientes',
  secondBenefitDescription:
    'Atraímos novos clientes na sua região ampliando sua atuação.',
  thirdBenefitTitle: 'Sua loja digitalizada',
  thirdBenefitDescription:
    'Uma forma de você vender mais sem pagar nada por isso.',
  fourthBenefitTitle: 'Incentivo operacional',
  fourthBenefitDescription: 'Pagamos incentivo por qualidade nas entregas.',
  zeDeliveryTitle: 'Como funciona o Zé Delivery?',
  zeDeliveryContent:
    'Somos um serviço que entrega bebidas geladas e petiscos em até 35 minutos. Conectamos sua loja a consumidores na região promovendo a venda dos seus produtos.',
  illustrationDeliveryMan: 'Ilustração de um Delivery Man',
  stepsTitle: 'Passos para começar',
  requirementsTitle: 'O que é necessário para se cadastrar',
  firstStepTitle: 'Cadastro',
  secondStepTitle: 'Validação',
  thirdStepTitle: 'Treinamento',
  fourthStepTitle: 'Operação',
  firstStepDescription: 'Completar o cadastro com as informações da sua loja.',
  secondStepDescription:
    'Conforme a necessidade de parceiros por região, validamos e auditamos o seu cadastro.',
  thirdStepDescription:
    'Treinamos você para operar com qualidade na nossa plataforma.',
  fourthStepDescription:
    'Gerenciar pedidos, completar as entregas e receber semanalmente.',
  firstRequirementTitle: 'Bebida gelada',
  secondRequirementTitle: 'Pagamento',
  thirdRequirementTitle: 'Internet',
  fourthRequirementTitle: 'Entrega',
  fifthRequirementTitle: 'Cupom fiscal',
  sixthRequirementTitle: 'Código CNAE',
  firstRequirementDescription:
    'Ter capacidade para armazenar e gelar cervejas e outros tipos de bebidas.',
  secondRequirementDescription:
    'Aceitar pagamentos de cartões de crédito, débito e dinheiro.',
  thirdRequirementDescription: 'Ter um computador com acesso à internet.',
  fourthRequirementDescription:
    'Ter capacidade para cuidar da logística e dos custos operacionais de entrega.',
  fifthRequirementDescription:
    'Possuir CNPJ ativo e emitir cupom fiscal das vendas.',
  sixthRequirementDescription:
    'Ter o CNPJ com o CNAE relacionado à venda de bebidas e alimentos.',
  logo: 'Logo do Zé Delivery',
  titleHowItWorks: 'Ir para o texto sobre a parceria com o Zé',
  titleStepByStep: 'Ir para o texto sobre o processo para iniciar a parceria',
  titlePrerequisites: 'Ir para o texto com os pré-requisitos',
  loginHeader: 'JÁ SOU PARCEIRO',
  textHowItWorks: 'Como funciona',
  textStepByStep: 'Passo a passo',
  textPrerequisites: 'Pré-requisitos',
  burgerImage: 'Ver opções de navegação pelo menu',
  closeImage: 'Fechar menu e continuar navegação',
  firstBenefitImage: 'Representação de divulgação',
  secondBenefitImage: 'Representação de novos clientes',
  thirdBenefitImage: 'Representação de loja digitalizada',
  fourthBenefitImage: 'Representação de incentivo operacional',
  firstStepImage: 'Representação de cadastro',
  secondStepImage: 'Representação de validação',
  thirdStepImage: 'Representação de treinamento',
  fourthStepImage: 'Representação de operação',
  firstRequirementImage: 'Representação de bebida gelada',
  secondRequirementImage: 'Representação de pagamento',
  thirdRequirementImage: 'Representação de internet',
  fourthRequirementImage: 'Representação de entrega',
  fifthRequirementImage: 'Representação de cupom fiscal',
  sixthRequirementImage: 'Representação de código CNAE',
  loginLink: 'Ir para login da área do parceiro',
}

export default LANDING_PAGE_PDV
